// Byte-for-byte aligned with the API's contract (api/app/shared/constants/procedureIndexState.ts's
// PROCEDURE_INDEX_DISPLAY_STATUS and api/app/shared/schemas/procedureIndexStatus.schemas.ts).

export enum ProcedureIndexDisplayStatus {
  INDEXED = "indexed",
  SKIPPED = "skipped",
  FAILED = "failed",
  REMOVED = "removed",
  NEVER_INDEXED = "never_indexed",
  NOT_APPLICABLE = "not_applicable",
}

/** One procedure's indexing status. `procedureStatus` is left a plain string, matching how the
 * existing `Procedure` model types it on this side (no PROCEDURE_STATUS enum exists on web). */
export interface ProcedureIndexStatusRow {
  procedureId: number;
  name: string;
  procedureStatus: string;
  isDeleted: boolean;
  indexStatus: ProcedureIndexDisplayStatus;
  sourceModifiedAt: string | null;
  lastIndexedAt: string | null;
  lastError: string | null;
  chunkCount: number;
}

export type ProcedureIndexStatusCounts = Record<ProcedureIndexDisplayStatus, number>;

/** 1-indexed on the wire — BOTH page and limit are required; the server 400s on either being absent. */
export interface ProcedureIndexStatusFilter {
  page: number;
  limit: number;
}

/** `{ results, total, counts }` — `total` and `counts` cover every procedure, not just this page. */
export interface ProcedureIndexStatusResponse {
  results: ProcedureIndexStatusRow[];
  total: number;
  counts: ProcedureIndexStatusCounts;
}
